/**
 * Metadados de rota (title/description) para EN e ES.
 *
 * Por que existe: o `head()` de uma rota faz parte do bundle **crítico** do
 * TanStack Router. Se as rotas `/$locale/*` importassem os dicionários
 * completos, os ~30 KB de strings EN/ES entrariam no JS inicial de TODAS as
 * páginas — inclusive da home pt-BR. Aqui ficam apenas as poucas strings
 * necessárias no head; o dicionário completo de EN/ES é carregado por
 * `import()` dinâmico no LocaleProvider.
 */
export type RouteMetaLocale = "en" | "es";

export const ROUTE_META: Record<
  RouteMetaLocale,
  {
    home: { metaTitle: string; metaDesc: string; mockupTitle: string };
    contactPage: { metaTitle: string; metaDesc: string };
  }
> = {
  en: {
    home: {
      metaTitle: "Kentro — Chat + CRM + AI: serve and sell more",
      metaDesc:
        "Turn every conversation into organized support, tracked sales and predictable growth. WhatsApp API, CRM and AI 24/7 in one platform.",
      mockupTitle: "Kentro · Omnichannel inbox",
    },
    contactPage: {
      metaTitle: "Contact — Kentro Sistemas",
      metaDesc:
        "Talk to Kentro: book a demo, ask questions or request a proposal. We answer via WhatsApp, phone and email.",
    },
  },
  es: {
    home: {
      metaTitle: "Kentro — Chat + CRM + IA: atiende y vende más",
      metaDesc:
        "Transforma cada conversación en atención organizada, venta acompañada y crecimiento previsible. WhatsApp API, CRM e IA 24/7.",
      mockupTitle: "Kentro · Bandeja omnicanal",
    },
    contactPage: {
      metaTitle: "Contacto — Kentro Sistemas",
      metaDesc:
        "Habla con Kentro: agenda una demo, resuelve dudas o pide una propuesta. Atendemos por WhatsApp, teléfono y correo.",
    },
  },
};
